export const environment = {
  production: false,
  //apiUrl: 'https://localhost:7011/api'
  apiUrl: 'https://facturacionapi.aciertosoft.com/api'// Cambiar por la URL real de producción
};
